/**
 * The regime a cohort runs under (12.10.2026): the programme accredited by the
 * ministry, or a "Curs FPED" — the same course outside the accreditation.
 * The server decides and enforces (`services/groups/regime.py`); this only
 * words the pages by it. Works on a cohort and on an enrolment alike: the
 * regime is copied onto the enrolment when it is made.
 */
export const ACCREDITED = "acreditat";
export const FPED = "fped";

export const REGIME_OPTIONS = [
  { value: ACCREDITED, label: "Acreditat MEC",
    hint: "Programul acreditat prin OMEC: calendarul ministerului, registrul formabililor, anexele." },
  { value: FPED, label: "Curs FPED",
    hint: "Același curs, după regulile FPED: fără calendarul ministerului, fără raportare, fără card Prima." },
];

/** Missing means accredited: every cohort and enrolment made before the regime existed. */
export function isFped(doc) {
  return doc?.regime === FPED;
}

/** "Curs FPED", or null for the accredited programme, as most cohorts are. */
export function regimeChip(group) {
  return isFped(group) ? "Curs FPED" : null;
}

/** Why the regime cannot be chosen or changed here, or "" when it can. */
export function regimeLock(form, enrolled = 0, saved = null) {
  if (saved && enrolled > 0) return "Regimul nu se mai schimbă după prima înscriere.";
  if (form?.access !== "link") return "Regimul „Curs FPED” e disponibil doar la grupele cu link de înscriere.";
  return "";
}

/** A contract made on the Curs FPED text: its version says so (`fped-…`). */
export function isFpedContract(contract) {
  return String(contract?.template_version || "").startsWith("fped-");
}

/** The contract by its name: a Curs FPED cohort signs a contract of participation. */
export function contractTitle(fped) {
  return fped ? "Contract de participare la curs" : "Contract de formare";
}

/** What the team calls the data asked for after payment, by regime. */
export function dossierTitle(fped) {
  return fped ? "Date pentru contract și certificat" : "Date pentru minister";
}
